import { Button } from 'src/v2/commonComponents/Button';
import styles from './SubmitTranslation.module.scss';

interface SubmitTranslationProps {
  isSubmitDisabled: boolean;
  isResetDisabled?: boolean;
  onReset: () => void;
  onSubmit: () => void;
}

export const SubmitTranslation = ({
  isSubmitDisabled,
  isResetDisabled,
  onReset,
  onSubmit,
}: SubmitTranslationProps) => {
  return (
    <div className={styles.root}>
      <Button
        disabled={isResetDisabled}
        color="secondary-outline"
        className={styles.button}
        onClick={onReset}
      >
        Cancel
      </Button>

      <Button
        disabled={isSubmitDisabled}
        className={styles.button}
        onClick={onSubmit}
      >
        Translate
      </Button>
    </div>
  );
};
